import { DateTimeField, TextField } from "@dgs/core";
import { FC } from "react";
import { LanguageSingleSelectField } from "../shared/select/LanguageSingleSelectField";
import { ContactAttributeResourceColumn } from "../shared/types";
import { BetweenDateTimeValueField } from "./BetweenValueField";
import { ContactFilterOperatorAndValue } from "./ContactFilterOperatorAndValue";
import { IFilterEntryDescription } from "./types";

interface Props {
	name: string;
	attribute: ContactAttributeResourceColumn;
}

const descriptions: Record<ContactAttributeResourceColumn["entityType"], IFilterEntryDescription> = {
	firstName: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY", "CONTAINS", "NOT_CONTAINS", "EQUAL", "NOT_EQUAL"],
		render: (props) => <TextField {...props} />,
	},
	lastName: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY", "CONTAINS", "NOT_CONTAINS", "EQUAL", "NOT_EQUAL"],
		render: (props) => <TextField {...props} />,
	},
	createdAt: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY", "GREATER_THAN_EQUAL", "LESS_THAN_EQUAL", "EQUAL", "NOT_EQUAL", "BETWEEN"],
		render: (props, operator) => {
			switch (operator) {
				case "BETWEEN":
					return <BetweenDateTimeValueField name={props.name} />;
				default:
					return <DateTimeField {...props} />;
			}
		},
	},
	id: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY"],
	},
	updatedAt: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY", "GREATER_THAN_EQUAL", "LESS_THAN_EQUAL", "EQUAL", "NOT_EQUAL", "BETWEEN"],
		render: (props, operator) => {
			switch (operator) {
				case "BETWEEN":
					return <BetweenDateTimeValueField name={props.name} />;
				default:
					return <DateTimeField {...props} />;
			}
		},
	},
	locale: {
		operators: ["IS_EMPTY", "IS_NOT_EMPTY", "EQUAL", "NOT_EQUAL"],
		render: (props) => <LanguageSingleSelectField {...props} />,
	},
};

export const ContactFilterColumnEntry: FC<Props> = ({ name, attribute }) => {
	return (
		<ContactFilterOperatorAndValue
			name={name}
			type={attribute.entityType}
			description={descriptions[attribute.entityType]}
		/>
	);
};
